import { Action, combineReducers } from 'redux';

import { contentMoreItemsForTokenRequestReducer } from '~src/app/reducers/contentExplorer/ContentMoreItemsForTokenRequestReducer';
import { contentNextPageTokenReducer } from '~src/app/reducers/contentExplorer/ContentNextPageTokenReducer';
import { contentTotalCountReducer } from '~src/app/reducers/contentExplorer/ContentTotalCountReducer';

import { ContentExplorerState, ContentState, SelectionState } from '../../state/ContentExplorerState';
import { contentCountsReducer } from './ContentCountsReducer';
import { contentFetchBusyReducer } from './ContentFetchBusyReducer';
import { contentReducer } from './ContentReducer';
import { contentTypeFilterValuesReducer } from './ContentTypeReducer';
import { mixedContentFilterReducer } from './MixedContentFilterReducer';
import { selectedItemsReducer } from './SelectedItemsReducer';
import { selectionBusyReducer } from './SelectionBusyReducer';
import { showWorkbooksAsViewsReducer } from './ShowWorkbooksAsViewsReducer';

export const contentExplorerReducer: (
  previousState: ContentExplorerState,
  action: Action
) => ContentExplorerState = combineReducers<ContentExplorerState>(
  {
    content: combineReducers<ContentState>({
      contentItems: contentReducer,
      isBusy: contentFetchBusyReducer,
      contentNextPageToken: contentNextPageTokenReducer,
      totalCount: contentTotalCountReducer,
      moreItemsForTokenRequest: contentMoreItemsForTokenRequestReducer
    }),
    contentCounts: contentCountsReducer,
    contentTypeFilterValues: contentTypeFilterValuesReducer,
    mixedContentFilterClauses: mixedContentFilterReducer,
    selection: combineReducers<SelectionState>({
      selectedItems: selectedItemsReducer,
      isBusy: selectionBusyReducer
    }),
    showWorkbooksAsViews: showWorkbooksAsViewsReducer
  }
);
